export default "__VITE_ASSET__9c3f9b9a__"